//------------------------------
// auto roll combatant type srs
//------------------------------
export default function autoRollCombatantSRs(combatants, type) {
  // console.log("-------------------");
  // console.log("IN autoRollCombatantSRs type = " + type);
  //---------------------------
  // get active combatant type
  //---------------------------
  let actives = combatants.filter(
    (a) => a.status == "Active" && a.type == type
  );
  //---------------------
  // where active troops
  //---------------------
  if (actives) {
    //---------------------------
    // calculate sr where sr = 0 
    //---------------------------
    actives.forEach((a) => {
      if (a.sr_roll == 0) {
        let sr = Math.floor(Math.random() * 10) + 1;
        a.sr_roll = sr;
      }
    });
  }
  return combatants;
}
